export default class CatalogCompConst {
    
    static COMPONENTSAPP_COMP='componentsapp-comp'
    static COMPONENTSAPP_CTRL='componentsapp-ctrl'
    static TIPOATTR_EVT='tipoattr-evt'
    static COMPONENTSAPP_COMPI='componentsapp-compi'
    
  }
  